import { useTranslation } from 'react-i18next'

import TransparentTile from '../../../TransparentTile/TransparentTile'
import styles from './ExtraTip.module.scss'

function ExtraTip() {
  const { t } = useTranslation()

  return (
    <div className={styles.extraTipContent}>
      <p className={`title-large ${styles.extraTipTitle}`}>
        {t('MOBILE_APP.GRADIENT_DRAWER.EXTRA_TIP.HEADER.TITLE')}
      </p>

      <div className={styles.paymentsDetailsContainer}>
        <div className={styles.paymentDetailsDescriptionContainer}>
          <p className={`body-medium ${styles.summaryTitle}`}>
            {t('MOBILE_APP.GRADIENT_DRAWER.EXTRA_TIP.SUMMARY.TITLE')}
          </p>
        </div>
        <div className={`title-large ${styles.summaryPrice}`}>$ 26.00</div>
      </div>

      <TransparentTile>
        <div className={styles.enteredAmountContainer}>
          <p className={`body-medium ${styles.enteredAmountTitle}`}>
            {t(
              'MOBILE_APP.GRADIENT_DRAWER.EXTRA_TIP.SUMMARY.AMOUNT_YOU_ENTERED'
            )}
          </p>
          <p className={`headline-large ${styles.enteredAmountPrice}`}>
            $ 26.00
          </p>
        </div>
      </TransparentTile>
    </div>
  )
}

export default ExtraTip
